import { render, staticRenderFns } from "./transferordermanagement.vue?vue&type=template&id=1f564d17&scoped=true"
import script from "./transferordermanagement.vue?vue&type=script&lang=js"
export * from "./transferordermanagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f564d17",
  null
  
)

export default component.exports